import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '.';
import { CONTROLLERS, ENDPOINTS } from '../constants';
import {
  CreateTenantDBAndSubscriptionCommand,
  CustomerInfo,
  Response,
  UpdateAgreementAcceptanceReq2,
  UpdateCustomerCommand,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private api: string = CONTROLLERS.CUSTOMER;
  constructor(private apiService: ApiService) { }
  getById(customerId: number): Observable<Response<CustomerInfo>> {
    return this.apiService.get(
      `${this.api}/${ENDPOINTS.CUSTOMER.GET_CUSTOMER_BY_ID}/${customerId}`
    );
  }

  updateCustomer(body: UpdateCustomerCommand): Observable<Response<boolean>> {
    return this.apiService.put('', `${this.api}/${ENDPOINTS.CUSTOMER.UPDATE_CUSTOMER}`, body);
  }

  updateAgreementAcceptance(
    updateReqCommand: UpdateAgreementAcceptanceReq2
  ): Observable<Response<boolean>> {
    return this.apiService.put(
      '',
      `${this.api}/${ENDPOINTS.CUSTOMER.UPDATE_AGREEMENT_ACCEPTANCE}`,
      updateReqCommand
    );
  }

  createTenantDBAndSubscription(body: CreateTenantDBAndSubscriptionCommand): Observable<Response<boolean>> {
    return this.apiService.post(`${this.api}/${ENDPOINTS.CUSTOMER.CREATE_TENANTDB_AND_SUBSCRIPTION}`, body);
  }
}
